var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.321 5.273a8.7 8.7 0 0 0-3.094-3.139L9 2l-.227.134a8.64 8.64 0 0 0-3.129 3.2 8.9 8.9 0 0 0-1.139 4.672c.045 1.36.554 2.504 1.47 3.309a4.5 4.5 0 0 0 2.571 1.081V16h.908V8.572h-.908v4.89c-1.534-.182-3.06-1.29-3.134-3.487a8 8 0 0 1 .957-4.056A7.8 7.8 0 0 1 9 3.078a7.8 7.8 0 0 1 2.63 2.84 8 8 0 0 1 .957 4.056c-.058 1.758-1.047 2.818-2.225 3.265v.983a4.4 4.4 0 0 0 1.663-.908c.916-.805 1.425-1.95 1.47-3.309a8.9 8.9 0 0 0-1.174-4.734Z"
  })));
};
export default SvgLeaf;